// extracted by mini-css-extract-plugin
export default {"root":"AppModule_root__rv9HN","sidebar":"AppModule_sidebar__Otquw","header":"AppModule_header__eO+eW","content":"AppModule_content__EXO9C"};